import { useEffect, useState } from 'react'
import { getReferralByCode } from '../api/api'
import { useLoadingStore } from '@caradasstore/LoadingStore'
import { sameCarrier } from '../utils/fuzzyMatchClients'

export const useInitReferralAndInsuranceFromState = ({
  referralSourceCode,
  insuranceCompanies,
  setFormInputValues,
  setAutoMatchedReferral,
  setShowReferralField,
  ccId
}) => {
  const [referralData, setReferralData] = useState(null)
  const setLoading = useLoadingStore((state) => state.setLoading)

  useEffect(() => {
    const initReferral = async () => {
      if (!referralSourceCode || insuranceCompanies.length === 0) return

      try {
        setLoading(true)
        // Fetch referral info by code
        const referralResponse = await getReferralByCode({
          ccId,
          code: referralSourceCode
        })

        const referral = referralResponse?.data
        if (!referral) {
          console.warn('No referral data returned')
          return
        }
        setReferralData(referral)

        // Auto-match insurance if name matches referralSourceCode
        // Exact name first; otherwise the same carrier under another spelling (the agreement "State Farm" picks the
        // "State Farm" insurer, or "State Farm Insurance Companies" when that is the only one listed).
        const agreement = referral?.company
        const matchedInsurance = agreement
          ? (insuranceCompanies.find((company) => company?.name?.toLowerCase() === agreement.toLowerCase()) ??
            insuranceCompanies.find((company) => sameCarrier(company?.name, agreement)))
          : undefined

        if (matchedInsurance) {
          setFormInputValues((prev) => ({
            ...prev,
            insurance_company_id: matchedInsurance.id,
            referral_source_code: referralSourceCode
          }))
          setAutoMatchedReferral?.(matchedInsurance)
          setShowReferralField?.(false)
        } else {
          // If no insurance match, still set referral_source_code
          setFormInputValues((prev) => ({
            ...prev,
            referral_source_code: referralSourceCode
          }))
          setShowReferralField?.(true)
        }
      } catch (error) {
        console.error('Error fetching referral or matching insurance:', error)
      } finally {
        setLoading(false)
      }
    }

    initReferral()
  }, [referralSourceCode, insuranceCompanies, ccId])
}
